import { render } from "./form_6.vue?vue&type=template&id=fdfa2386"
import script from "./form_6.vue?vue&type=script&lang=js"
export * from "./form_6.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/forms/form_6.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fdfa2386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fdfa2386', __exports__)) {
    console.log('reload')
    api.reload('fdfa2386', __exports__)
  }
  
  module.hot.accept("./form_6.vue?vue&type=template&id=fdfa2386", () => {
    console.log('re-render')
    api.rerender('fdfa2386', render)
  })

}


export default __exports__